document.addEventListener('DOMContentLoaded', () => {
  initMobileMenu();
  initAccordions();
  initQuantitySelectors();
  initProductGallery();
  initCollectionSort();
  initScrollAnimations();
  initHeroSlideshow();
  initScrollReveal();
  initQuickAdd();
});

function initMobileMenu() {
  const toggle = document.querySelector('.header__toggle');
  const nav = document.querySelector('.header__nav');

  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      nav.classList.toggle('active');
    });
  }
}

function initAccordions() {
  const accordionHeaders = document.querySelectorAll('.accordion-item__header');

  accordionHeaders.forEach(header => {
    header.addEventListener('click', () => {
      const isExpanded = header.getAttribute('aria-expanded') === 'true';

      accordionHeaders.forEach(h => {
        h.setAttribute('aria-expanded', 'false');
      });

      if (!isExpanded) {
        header.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

function initQuantitySelectors() {
  const minusBtns = document.querySelectorAll('[data-qty-minus]');
  const plusBtns = document.querySelectorAll('[data-qty-plus]');

  minusBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('.quantity-selector__input');
      const currentValue = parseInt(input.value);
      if (currentValue > 1) {
        input.value = currentValue - 1;
      }
    });
  });

  plusBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('.quantity-selector__input');
      const currentValue = parseInt(input.value);
      input.value = currentValue + 1;
    });
  });
}

function initProductGallery() {
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImages = document.querySelectorAll('.product-gallery__main-img');

  console.log('Product gallery initialized:', {
    thumbCount: thumbs.length,
    mainImageCount: mainImages.length
  });

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const thumbIndex = parseInt(thumb.getAttribute('data-thumb-index'));
      console.log('Thumbnail clicked:', thumbIndex);

      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');

      mainImages.forEach((img, index) => {
        console.log(`Image ${index}: index=${index}, thumbIndex=${thumbIndex}, match=${index === thumbIndex}`);
        if (index === thumbIndex) {
          img.classList.add('active');
        } else {
          img.classList.remove('active');
        }
      });
    });
  });
}

function initCollectionSort() {
  const sortSelect = document.getElementById('sort-by');

  if (sortSelect) {
    sortSelect.addEventListener('change', (e) => {
      const url = new URL(window.location);
      url.searchParams.set('sort_by', e.target.value);
      window.location = url.toString();
    });

    const urlParams = new URLSearchParams(window.location.search);
    const currentSort = urlParams.get('sort_by');
    if (currentSort) {
      sortSelect.value = currentSort;
    }
  }
}

function initScrollAnimations() {
  const observerOptions = {
    threshold: 0.15,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-in');
      }
    });
  }, observerOptions);

  const animatedElements = document.querySelectorAll(
    '.benefits-section, .benefit-item, .featured-collections, .collection-card, ' +
    '.best-sellers-section, .product-card, .story-block, .lifestyle-gallery, ' +
    '.reviews-section, .review-card, .newsletter-bar, .section-heading'
  );

  animatedElements.forEach((el, index) => {
    el.style.setProperty('--animation-order', index);
    observer.observe(el);
  });
}

function initHeroSlideshow() {
  const slideshow = document.querySelector('.hero-slideshow');
  if (!slideshow) return;

  const slides = slideshow.querySelectorAll('.hero-slide');
  const dots = slideshow.querySelectorAll('.hero-slideshow__dot');

  if (slides.length <= 1) return;

  let currentSlide = 0;
  let autoplayInterval;

  function goToSlide(index) {
    slides[currentSlide].classList.remove('active');
    dots[currentSlide].classList.remove('active');

    currentSlide = index;

    if (currentSlide < 0) {
      currentSlide = slides.length - 1;
    } else if (currentSlide >= slides.length) {
      currentSlide = 0;
    }

    slides[currentSlide].classList.add('active');
    dots[currentSlide].classList.add('active');
  }

  function nextSlide() {
    goToSlide(currentSlide + 1);
  }

  function startAutoplay() {
    autoplayInterval = setInterval(nextSlide, 5000);
  }

  function stopAutoplay() {
    if (autoplayInterval) {
      clearInterval(autoplayInterval);
    }
  }

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      stopAutoplay();
      goToSlide(index);
      startAutoplay();
    });
  });

  slideshow.addEventListener('mouseenter', stopAutoplay);
  slideshow.addEventListener('mouseleave', startAutoplay);

  startAutoplay();
}

function initScrollReveal() {
  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('scroll-revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.2,
      rootMargin: '0px 0px -100px 0px'
    }
  );

  const revealElements = document.querySelectorAll('[data-scroll-reveal]');
  revealElements.forEach((el) => {
    revealObserver.observe(el);
  });
}

document.addEventListener('scroll', () => {
  const header = document.querySelector('.site-header');
  if (window.scrollY > 100) {
    header?.classList.add('scrolled');
  } else {
    header?.classList.remove('scrolled');
  }
});

function initQuickAdd() {
  const quickAddButtons = document.querySelectorAll('.product-card__quick-add');

  quickAddButtons.forEach(button => {
    button.addEventListener('click', async (e) => {
      e.preventDefault();

      const productCard = button.closest('.product-card');
      const productLink = productCard.querySelector('.product-card__link');
      const productUrl = productLink.getAttribute('href');

      button.disabled = true;
      button.textContent = 'Adding...';

      try {
        const response = await fetch(productUrl + '.js');
        const product = await response.json();

        const firstAvailableVariant = product.variants.find(v => v.available);

        if (!firstAvailableVariant) {
          throw new Error('Product not available');
        }

        const formData = {
          id: firstAvailableVariant.id,
          quantity: 1
        };

        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData)
        });

        if (!addResponse.ok) {
          throw new Error('Failed to add to cart');
        }

        button.textContent = 'Added!';
        button.classList.add('success');

        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        updateCartCount(cart.item_count);

        setTimeout(() => {
          button.disabled = false;
          button.textContent = 'Quick Add';
          button.classList.remove('success');
        }, 2000);

      } catch (error) {
        console.error('Error adding to cart:', error);
        button.textContent = 'Error';
        button.classList.add('error');

        setTimeout(() => {
          button.disabled = false;
          button.textContent = 'Quick Add';
          button.classList.remove('error');
        }, 2000);
      }
    });
  });
}

function updateCartCount(count) {
  const cartCountElements = document.querySelectorAll('.cart-count, [data-cart-count]');
  cartCountElements.forEach(element => {
    element.textContent = count;
    if (count > 0) {
      element.style.display = 'inline';
    }
  });
}
